import './index.css';

const DashboardButtonsContainer = ({ children }) => {
    return (
        <div className="dashboard-buttons-container">
            {children}
        </div>
    )
}

export default DashboardButtonsContainer;